import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Lottie from "lottie-react";
const LottieViewer = (props) => {
  const [titleImg, updateTitleImg] = useState(null);
  const { location_path } = props;
  useEffect(() => {
    get_json_data()
  }, [])
  const get_json_data = async () => {
    let res = await axios.get(location_path)
    if (res.data) {
      updateTitleImg(res.data);
    }
  }
  return (
    <Lottie animationData={titleImg} />
  )
}
export default LottieViewer;